<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddDevice">Add Device</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="devices" :options="options" :theme="theme" id="dataTable" ref="dataTable">
        <template slot="enabled" slot-scope="data">
          {{getIsEnabledLable(data.row)}}
        </template>
        <template slot="actions" slot-scope="data">
          <b-btn size="sm" variant="outline-primary" @click="showEditDevice(data.row)" class="mr-1">Edit</b-btn>
        </template>
      </v-client-table>
    </b-card>
    <div>
      <b-modal ref="modalEditDevice" title="Edit Device" hide-footer @hide="hideEditDevice">
        <device-edit v-if="selectedDevice"  :selectedDevice="selectedDevice" @success="editDeviceSuccess" @cancel="cancelEditDevice" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalAddDevice" title="Add Device" hide-footer >
        <device-add  @success="addDeviceSuccess" @cancel="cancelAddDevice" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import DeviceEdit from './DeviceEdit'
  import DeviceAdd from './DeviceAdd'
  import filter from 'lodash/filter'


  export default {
    name: 'DeviceList',

    components: {
      DeviceEdit,
      DeviceAdd
    },

    data: function() {
      return {

        selectedDevice: Object,
        columns: ['mac', 'enabled','description', 'actions'],
        options: {
          headings: {
            mac: 'Device Mac Address',
            enabled: 'Enabled?'
          },
          sortable: ['enabled'],
          filterable: ['enabled', 'mac'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,

        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      devices(){
        return this.$store.state.pos.devices;
      },
    },
    methods: {
      showAddDevice(){
        this.$refs.modalAddDevice.show();
      },
      cancelAddDevice() {
        this.$refs.modalAddDevice.hide()
      },
      addDeviceSuccess(device) {
        this.$refs.modalAddDevice.hide();
        this.$store.dispatch('pos/getDevices')
      },
      getIsEnabledLable(device){
         return device.enabled == 1 ? 'Yes' : 'No';
      },
      showEditDevice(device) {
        this.selectedDevice = device
        this.$refs.modalEditDevice.show()
      },
      cancelEditDevice() {
        this.$refs.modalEditDevice.hide()
      },
      editDeviceSuccess() {
        this.$refs.modalEditDevice.hide();
        this.$store.dispatch('pos/getDevices')
      },
      hideEditDevice() {
        this.selectedDevice = null
      },
    },
    created() {
      if (this.$store.state.pos.devices.length == 0) {
        this.$store.dispatch('pos/getDevices');
      }
    }
  }
</script>

<style lang="css">
</style>
